// extracted by mini-css-extract-plugin
export var container = "_85-0";
export var containerTopRight = "_85-1";